
export const display = {
  name: 'display'
}

export const float = {
  name: 'float'
}

export const clear = {
  name: 'clear'
}

export const zIndex = {
  name: 'z-index',
  unit: ''
}

export const boxSizing = {
  name: 'box-sizing'
}